<template>
  <div>已跳转中瀚地图大屏页面，请在新页面查看</div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  created () {
    this.tiaoZhuan()
  },
  methods: {
    tiaoZhuan () {
      window.open('http://any.zw56.com/#/socStockHongtuDp')
    }
  }
}
</script>
<style>

</style>
